import type { GameId } from "./games";

/*
 * THE END OF A TRICK — ONE SET OF NUMBERS FOR THE FELT THAT HOLDS IT AND THE SERVER THAT TIMES IT.
 *
 * حکم's, بی‌دل's and شلم's felts hold a finished trick on screen — the winning card included — and then
 * sweep it toward its winner (`apps/web/src/game/use-trick-hold.ts`). While it is held, YOUR HAND'S
 * PLAYS ARE DISABLED: a card played into it would only queue behind the collect. The trick's winner
 * leads the next one, so the hold is spent on THEIR turn.
 *
 * Operator, 2026-10-11 (card-a5 item 7): «At the end of a trick the winner's hand is held for about
 * 1 s while their turn timer runs. Give that time back.» The game-server's turn window used to open
 * the instant the trick completed, so the winner's ring was already counting — and the server's
 * auto-play already due — through the whole hold. Since item 7 that window, still armed at once, ENDS
 * {@link TRICK_END_HOLD_MS} later (`apps/game-server/src/rooms/trick-end-hold.ts`) and its ring stays full
 * through the hold: the deadline moves, not just the drawing of it, so the auto-play can never fire early.
 *
 * SHARED so the two cannot drift: the felt reads these constants for its hold, the server reads the
 * same sum for its deadline. Change one and you have changed both.
 */

/** How long the four finished cards HOLD on the felt — the winning card included — before the
 *  collect starts. */
export const TRICK_HOLD_MS = 600;

/** The collect sweep. `TRICK_HOLD_MS + TRICK_COLLECT_MS` stays UNDER the engines' 1100 ms pause before
 *  a BOT's next lead (`postMoveDelayMs`), so a bot's lead never waits on it. */
export const TRICK_COLLECT_MS = 350;

/** The whole hold + collect: how long the winner's hand stays disabled at the end of a trick, and so
 *  how much later the server ends their turn window. */
export const TRICK_END_HOLD_MS = TRICK_HOLD_MS + TRICK_COLLECT_MS;

/**
 * The games whose felt holds a finished trick with the hand disabled — exactly the three tables that
 * call `useTrickHold`: حکم, بی‌دل and شلم (since its P1 rework `ShelemTable` disables every play while
 * `hold.holding`, so a شلم winner's window ran through the hold — card-a5 item 7's bug — until the
 * controller's ruling of 2026-10-13 put it here). پاسور and بلوف have no tricks to hold.
 */
export const TRICK_END_HOLD_GAMES = [
  "hokm",
  "hearts",
  "shelem",
] as const satisfies readonly GameId[];
export type TrickEndHoldGame = (typeof TRICK_END_HOLD_GAMES)[number];

export function isTrickEndHoldGame(game: string | undefined): game is TrickEndHoldGame {
  return game !== undefined && (TRICK_END_HOLD_GAMES as readonly string[]).includes(game);
}
